import useDocumentTitle from 'hooks/useDocumentTitle';
import "./dashboard.scss"
import CampaignActivity from 'Components/dashboard/CampaignActivity';
import OverallTaskSummary from 'Components/dashboard/OverallTaskSummary';
const Dashboard = () => {
    useDocumentTitle("Dashboard");

    return (
        <div className="page-content mb-3">
            <div className="d-flex flex-column gap-3">
                <OverallTaskSummary />
                <CampaignActivity />
            </div>
        </div>
    )
}

export default Dashboard